// Canonical lifecycle status badge (Blueprint §4.6 / D-32).
// One component, one colour map — replaces the drifting inline badges.

import { GROUP_BADGE_CLASSES, lifecycleGroup, lifecycleLabel } from "./lifecycle";

export function StatusBadge({ state, className = "" }: { state: string; className?: string }) {
  const group = lifecycleGroup(state);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-bold ${GROUP_BADGE_CLASSES[group]} ${className}`}
      title={state}
    >
      <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {lifecycleLabel(state)}
    </span>
  );
}
